
  import Vue from 'vue';
  import PopularCategoryCard from '@/components/PopularCategoryCard';
export default {
  components: {
    PopularCategoryCard
  },
  head() {
    return {
      title: this.title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.title,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: this.title,
        },

        {
  hid: 'description',
  name: 'description',
  content: 'Celebrate your love with a beautiful post-wedding photoshoot in Goa. Capture stunning memories against the backdrop of Goa’s scenic beaches and vibrant locations.',
},
{
  hid: 'og:description',
  property: 'og:description',
  content: 'Discover the perfect locations in Goa for a romantic post-wedding photoshoot. From beautiful beaches to iconic landmarks, capture your love in stunning detail.',
},
{
  hid: 'twitter:description',
  property: 'twitter:description',
  content: 'Book a post-wedding photoshoot in Goa and capture your love story. Enjoy beautiful photography at stunning locations, from beaches to iconic spots.',
},

        {
          hid: 'keywords',
          name: 'keywords',
          content: 'post wedding photography, what is post wedding photography, best post wedding photography, post wedding photography ideas, post wedding photography poses, post wedding shoot in goa, creative post wedding photography',
        },

      ],
    };
  },

  components: {},
  data() {
    return {

      reasons: [
    {
      title: "Stunning Locations",
      text: "Capture breathtaking views and hidden gems with the best photography spots in Goa!",
    },
    {
      title: "Perfect for Everyone",
      text: "Whether you're a pro or just starting, there's something for every photography lover!",
    },
    {
      title: "Local Experts",
      text: "Our experienced photographers guide you to the best locations and give helpful tips.",
    },
    {
      title: "Easy Booking",
      text: "Book your perfect photography experience easily through the Goa App at great rates!",
    },
  ],

      
      title: 'Post-Wedding Photography in Goa - Post-Wedding Photography Ideas and Poses',
    };
  },


  jsonld() {
  return {
    '@context': 'https://schema.org',
    '@graph': [
    {
                "@type": "ImageObject",
                "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D',
                "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D',
                "contentUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D',
                "caption": 'Goa App',
                "inLanguage": "en-US",
                "width": 800,
                "height": 440
            }, 
            {
            "@type": "BlogPosting",
            "@id": `https://www.goa.app/post-wedding-photography-goa`,
                mainEntityOfPage: {
                    '@type': 'WebPage',
                    '@id': `https://www.goa.app/post-wedding-photography-goa`
                },
                "headline": 'Goa App',
                "name": 'Goa App',
                description: '',
                datePublished: '2024-10-26T20:14:36+00:00',
                dateModified: '2024-10-26T20:14:36+00:00',
                author: {
                    '@type': 'Person',
                    name: 'Goa App',
                    url: "https://goa.app"
                },
                publisher: {
                    '@type': 'Organization',
                    "@id": "https://goa.app",
                    name: 'Goa App',
                    logo: {
                        '@type': 'ImageObject',
                        url: 'https://goa.app/goa-app-logo.svg'
                    }
                },
                "image": {
                    "@type": "ImageObject",
                    "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D',
                    "url": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D',
                    "height": "440",
                    "width": "800"
                },
                "url": `https://www.goa.app/post-wedding-photography-goa`,
                "isPartOf": {
                    "@type": "Blog",
                    "@id": "https://www.goa.app/",
                    "name": "Goa App Blog",
                    "publisher": {
                        "@type": "Organization",
                        "@id": "https://goa.app",
                        "name": "Goa App"
                    }
                },
            },
            
            {
  "@type": "Product",
  "name": "Post Wedding Photography in Goa - Book @ ₹4999 Flat 17% Off",
  "description": "Enjoy the best post wedding photography experience in Goa with stunning landscapes, vibrant culture, and unique moments captured for an unforgettable visual journey..",
  "image": "https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D",
  "review": {
    "@type": "Review",
    "reviewRating": {
      "@type": "Rating",
      "ratingValue": "5",
      "bestRating": "5"
    },
    "author": {
      "@type": "Person",
      "name": "Goa App"
    }
  },
  "brand": {
    "@type": "Brand",
    "name": "Goa App"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "ratingCount": "89",
    "ratingValue": "5",
    "reviewCount": "44"
  },
  "offers": {
    "@type": "Offer",
    "price": "4999",
    "priceValidUntil": "2025-12-31",
    "priceCurrency": "INR",
    "availability": "InStock",
    "seller": {
      "@type": "Organization",
      "name": "Goa App"
    }
  }
},

            {
        "@type": "WebPage",
        "@id": "https://www.goa.app/post-wedding-photography-goa",
        "url": "https://www.goa.app/post-wedding-photography-goa",
        "name": "Post Wedding Photography in Goa",
        "isPartOf": {
            "@id": "https://www.goa.app/#website"
        },
        "primaryImageOfPage": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D'
        },
        "image": {
            "@id": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D'
        },
        "thumbnailUrl": 'https://storage.googleapis.com/goa-app-12a91.appspot.com/2023-08-17T12%3A09%3A35.916Z2.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=h134a5GdgGPufDgBKoyzdYt%2FAxfpQvxvhQJJFVO%2F7X7Rj7A8oGBXj5l%2FUMHtlCVUP5kR9Zy4BB2fd3CIh9Ova9wdXmP75%2BUECpFPoH7LrZfg2xOkkYU%2BxIVo415rR%2Fw%2BgScSbpj3NVBpU4VnnOrreBwbjXabm1WI0cvo%2F9HKZ2xrHCBydDXpB%2FeltdvEPne8NobFqrLGbKum510CNgEzzkVIWaSQ4uZkUcb8fV0z355qhZONL%2Fmlg1JsxCSN7bZ%2BVzKSn90JHM76F6duB%2F7kSOqnttL2sNLx4bgnSfy6%2F%2BQ%2FJsNq4iD9bf1CrpYCst%2BA2fAfAuHisgjbqmlAubbigg%3D%3D',
        "datePublished": "2024-10-26T20:14:36+00:00",
        "dateModified": "2024-10-26T20:14:36+00:00",
        "description": "Post Wedding Photography in Goa captures the stunning beaches, vibrant culture, and scenic landscapes. It’s an ideal destination for photography enthusiasts looking to frame beautiful sunsets, historic sites, and lush greenery.",
        "breadcrumb": {
            "@id": "https://www.goa.app/post-wedding-photography-goa/#breadcrumb"
        },
        "inLanguage": "en-US",
        "potentialAction": [{
            "@type": "ReadAction",
            "target": ["https://www.goa.app/post-wedding-photography-goa"]
        }]
      },
      {
        "@type": "FAQPage",
  "mainEntity": [
  {
    "@type": "Question",
    "name": "What are the best locations for a post-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Some of the best locations for a post-wedding shoot in Goa include Vagator Beach, Chapora Fort, Fontainhas, Dudhsagar Falls, and secluded areas of Candolim Beach."
    }
  },
  {
    "@type": "Question",
    "name": "What types of post-wedding photography services are available in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "In Goa, you can find various post-wedding photography services, including beach sessions, romantic couple shoots, candid storytelling, and themed photoshoots at historical sites or natural landscapes."
    }
  },
  {
    "@type": "Question",
    "name": "How much does a post-wedding shoot cost in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Post-wedding shoot packages in Goa typically start from ₹4,999, depending on the location and the services included. Custom packages may vary based on additional features like drone photography or destination shoots."
    }
  },
  {
    "@type": "Question",
    "name": "Can I customize my post-wedding shoot package?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, many photographers in Goa offer customizable post-wedding shoot packages tailored to your preferences and vision for a personalized experience."
    }
  },
  {
    "@type": "Question",
    "name": "What is the best time for a post-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "The best time for a post-wedding shoot in Goa is during the golden hours, shortly after sunrise or before sunset, for stunning natural light and scenic backdrops."
    }
  },
  {
    "@type": "Question",
    "name": "Are there any restrictions on post-wedding photography at certain locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Yes, some locations in Goa may have restrictions on photography, particularly private properties or during certain events. It’s recommended to confirm any restrictions beforehand."
    }
  },
  {
    "@type": "Question",
    "name": "Do post-wedding photography packages include editing services?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Most post-wedding photography packages in Goa include basic editing services, with options for additional retouching or advanced edits available for an extra fee."
    }
  },
  {
    "@type": "Question",
    "name": "Can I choose my post-wedding shoot locations?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "Absolutely! Photographers in Goa often work closely with couples to select locations that resonate with their personal style and the mood they wish to capture."
    }
  },
  {
    "@type": "Question",
    "name": "What should I wear for a post-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "It is recommended to choose outfits that complement the chosen backdrop, with light fabrics and bright colors working well in Goa's tropical climate. Formal or casual attire can be selected depending on the theme."
    }
  },
  {
    "@type": "Question",
    "name": "How do I book a post-wedding shoot in Goa?",
    "acceptedAnswer": {
      "@type": "Answer",
      "text": "You can book a post-wedding shoot in Goa through various platforms, including the Goa App, which lists reputed photographers and their packages."
    }
  }
        ]
      }
    ]
  };
},


};



  